/**
 * 获取应用 链接
 *
 * 优先级： project - org - configs - self
 */
export const getAppLink = (app) => {
  return app?.custom?.project?.link || app?.custom?.org?.link || app?.configs?.link || app?.link
}

/**
 * 获取应用 链接跳转方式
 *
 * 优先级： project - org - configs - self
 */
export const getAppLinkTarget = (app) => {
  return app?.custom?.project?.target || app?.custom?.org?.target || app?.configs?.target || app?.target || '_self'
}

/**
 * 是否在新标签页打开
 */
export const isAppLinkOpenInNewTag = (app) => {
  return getAppLinkTarget(app) === '_blank'
}

/**
 * 获取应用 标题
 *
 * 优先级： project - org - configs - self
 */
export const getAppName = (app) => {
  return app?.custom?.project?.title || app?.custom?.org?.title || app?.configs?.title || app?.name
}

/**
 * 获取应用 标题
 *
 * 优先级： project - org - configs - self
 */
export const getAppIcon = (app) => {
  return app?.custom?.project?.icon || app?.custom?.org?.icon || app?.configs?.icon || app?.icon
}

/**
 * 是否为网络图片 图标
 */
export const isHttpIcon = (app) => {
  const iconUrl = getAppIcon(app)
  return (iconUrl?.startsWith('http://') || iconUrl?.startsWith('https://')) || false
}
